<template>
  <div class="container-fluid main">
    <div class="auth-panel">
      <div class="logo">
        <img
          src="@/assets/images/ghasforing-logo.png"
          class="img-responsive"
          alt=""
        />
      </div>
      <div class="fields pt30">
        <h3>Register Customer:</h3>
        <form v-on:submit.prevent>
          <input
            required
            v-model="email"
            class="form-control"
            autocomplete="email"
            placeholder="Email OR Phone Number"
          />
          <input
            required
            v-model="password"
            class="form-control"
            type="password"
            autocomplete="password"
            placeholder="Password"
            v-on:keyup.enter="loginCustomer"
          />
          <input
            required
            v-model="c_password"
            class="form-control"
            type="password"
            placeholder="Confirm Password"
            v-on:keyup.enter="loginCustomer"
          />

          <button @click="loginCustomer" type="submit" class="btn btn-login">
            Login
          </button>
        </form>
        <div class="text-right in-message">
          Have an Account?
          <router-link :to="{ path: '/login' }"
            ><span> Login</span></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import apiScript from "../apiScript";
// api.hello();
const $ = require("jquery");
window.$ = $;
$(function() {
  $(window).scroll(function() {
    $("nav").toggleClass("scrolled", $(this).scrollTop() > 30);
  });
});
import axios from "axios";
export default {
  data() {
    return {
      token: "",
      products: [],
      getcarts: [],
      modalProductData: [],
      carts: [],
      cartsCountProduct: "",
      loadMore: true,
      isOpen: true,
      sum_cart_total: "",
      quantity: 1,
      images: [],
      parseCartData: [],
      changeModalGallery_image: "",
      first_cats: [],
      second_cats: [],
      third_cats: [],
      fourth_cats: [],
      fifth_cats: [],
      sixth_cats: [],
      seventh_cats: [],
      eight_cats: []
      // swiperOption: {
      //   slidesPerView: 1,
      //   loop: true,
      //   autoplay: {
      //     delay: 2500,
      //     disableOnInteraction: false,
      //   },
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true,
      //   },
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   },
      // },
    };
  },
  created: function() {
    //document.title="home page";
    //this.getCategories();
    //localStorage.clear();
  },
  mounted() {
    // this.getImagesInfo()
    let vm = this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    vm.cartsCountProduct = JSON.parse(
      localStorage.getItem("cartsCountProduct")
    );
    this.calculateCartTotal();
  },
  methods: {
    loadApiData: function() {
      //localStorage.clear();
      let vm = this;
      vm.$parent.startLoading();
      axios
        .get(this.globalUrl + "products")
        .then(function(response) {
          vm.$parent.endLoading();
          //console.log(response.data.data);
          vm.products = response.data.data;
        })
        .catch(response => {
          vm.$parent.endLoading();
          vm.$toasted.show("Something wrong  Refresh again.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        });
    },
    quickView: function(id) {
      ///console.log(id);
      //localStorage.removeItem("recentViews");
      let index = this.products.findIndex(item => item.id === id);
      let vm = this;
      vm.modalProductData = this.products[index];
      //this  is  used  for  just chnage  folder  for  gallery  image and  featured  image in  moddak
      vm.changeModalGallery_image = this.products[index].featured_image;
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 1) {
      } else {
        this.quantity--;
      }
    },
    cartIncrement(product_id) {
      //alert(product_id);
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let newQuantity = oldQuantity + 1;
      let price = this.carts[objIndex].price;
      this.carts[objIndex].cart_quantity = newQuantity;
      this.carts[objIndex].subtotal = price * newQuantity;
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
      $("#" + product_id).addClass("animated");
      setTimeout(function() {
        $("#" + product_id).removeClass("animated");
      }, 500);
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
      }
      $("#" + product_id).addClass("animated");
      setTimeout(function() {
        $("#" + product_id).removeClass("animated");
      }, 500);
    },
    // getCategories: function(){
    //   let vm = this;
    //   //vm.$parent.startLoading();
    //   axios.get(this.globalUrl+"category")
    //     .then(function (response) {
    //       //console.log(response.data);
    //       vm.categories = response.data;
    //       //end loading
    //       // vm.$parent.endLoading();
    //     })
    //     .catch((response) => {
    //       //vm.$parent.endLoading();
    //       vm.$toasted.show('Something wrong  Try again.', {
    //         type: 'error',
    //         icon: 'fa-exclamation-triangle'
    //       });
    //     });
    // },
    removeCartItem: function(product_id) {
      //alert(product_id);
      this.carts = this.carts.filter(e => e.product_id !== product_id);
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    calculateCartTotal() {
      let vm = this;
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].subtotal
      );
      vm.sum_cart_total = sum;
      //calculate total  product  amount
      for (
        var i = 0, totalSum = 0;
        i < vm.carts.length;
        totalSum += vm.carts[i++].cart_quantity
      );
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    galleryImg: function(image_url) {
      let vm = this;
      vm.changeModalGallery_image = image_url;
    }
  }
};
</script>
